<template>
    <x-form-group label="Color Coding"
        help-text="Setting color coding untuk absensi group">
        <x-table :headers="[
            '',
            {
                'colspan': 2,
                'label': 'Range Persentase',
            },
            'Warna',
            '',
        ]">
            <tr v-for="(color, index) in fields.color_coding" :key="index">
                <td>
                    <x-delete-item-button @click="deleteColorCoding(index)" />
                </td>
                <td>
                    <x-input-group>
                        <template #prepend>
                            Min
                        </template>
                        <input type="number"
                            class="form-control"
                            v-model="color.percentage_min"
                            :name="`color_coding[${index}][percentage_min]`"
                            required />
                        <template #append>
                            %
                        </template>
                    </x-input-group>
                </td>
                <td>
                    <x-input-group>
                        <template #prepend>
                            Max
                        </template>
                        <input type="number"
                            class="form-control"
                            v-model="color.percentage_max"
                            :name="`color_coding[${index}][percentage_max]`"
                            required />
                        <template #append>
                            %
                        </template>
                    </x-input-group>
                </td>
                <td>
                    <input type="color"
                        class="form-control"
                        v-model="color.color"
                        :name="`color_coding[${index}][color]`"
                        required />
                </td>
                <td>
                    <x-checkbox-wrapper label="Highlight">
                        <input type="checkbox" :name="`color_coding[${index}][highlight]`" v-model="color.highlight" />
                    </x-checkbox-wrapper>
                </td>
            </tr>
            <template #footer="{ colspan }">
                <tr>
                    <td :colspan="colspan" class="text-center">
                        <x-add-item-button @click="addColorCoding" />
                    </td>
                </tr>
            </template>
        </x-table>
    </x-form-group>
</template>

<script>
import XAddItemButton from '../../components/XAddItemButton.vue'
import XCheckboxWrapper from '../../components/XCheckboxWrapper.vue'
import XDeleteItemButton from '../../components/XDeleteItemButton.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import XInputGroup from '../../components/XInputGroup.vue'
import XTable from '../../components/XTable.vue'

const defaultColorCoding = {
    color: null,
    percentage_max: 0,
    percentage_min: 0,
    highlight: false,
}

export default {
    components: { XFormGroup, XDeleteItemButton, XInputGroup, XAddItemButton, XTable, XCheckboxWrapper },
    data() {
        return {
            fields: {
                color_coding: [],
            }
        }
    },
    methods: {
        addColorCoding() {
            this.fields.color_coding.push({ ...defaultColorCoding })
        },
        deleteColorCoding(target) {
            this.fields.color_coding = this.fields.color_coding.filter((color, index) => {
                return index != target
            })
        }
    },
    mounted() {
        this.fields = JSON.parse($('meta[name="settings"]').attr('content'))
    }
}
</script>